import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { NewsCard } from "./NewsPages";

const API = process.env.REACT_APP_BACKEND_URL;

export const LatestNews = ({ t, lang }) => {
    const [latest, setLatest] = useState(null);

    useEffect(() => {
        let alive = true;
        fetch(`${API}/api/news?limit=3`)
            .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
            .then((data) => alive && setLatest(data))
            .catch(() => alive && setLatest([]));
        return () => {
            alive = false;
        };
    }, []);

    if (!latest || latest.length === 0) return null;

    return (
        <section className="bg-white py-24 md:py-32" data-testid="latest-news-section">
            <div className="mx-auto max-w-[1400px] px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="mb-12 flex flex-wrap items-end justify-between gap-6"
                >
                    <div>
                        <p className="text-xs font-bold uppercase tracking-[0.26em] text-[#0D9488] md:text-sm">{t.news.overline}</p>
                        <h2 className="font-display mt-4 text-4xl leading-tight tracking-tight text-[#0F172A] md:text-5xl">
                            {t.news.latestTitle}
                        </h2>
                    </div>
                    <a
                        href="/nea"
                        className="flex items-center gap-2 rounded-full border border-[#CBD5E1] px-6 py-3 text-sm font-bold text-[#0F172A] transition-colors duration-300 hover:border-[#0D9488] hover:text-[#0D9488]"
                        data-testid="latest-news-cta"
                    >
                        {t.news.latestCta}
                        <ArrowRight size={16} />
                    </a>
                </motion.div>
                <div className="grid grid-cols-1 gap-7 md:grid-cols-3" data-testid="latest-news-grid">
                    {latest.map((p) => (
                        <NewsCard key={p.slug} post={p} t={t} lang={lang} testId={`latest-news-card-${p.slug}`} light />
                    ))}
                </div>
            </div>
        </section>
    );
};
